// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-scroll-view {
    overflow-y: scroll;
    padding-bottom: 150px;
}

.detail-scroll-view::-webkit-scrollbar {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./../client/page/detail/views/content/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".detail-scroll-view {\n    overflow-y: scroll;\n    padding-bottom: 150px;\n}\n\n.detail-scroll-view::-webkit-scrollbar {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
